export function getView(infomationOnly, showProgressBar) {
  if (showProgressBar === false) {
    return false
  }

  if (!infomationOnly) {
    return true
  }
}
